const organization = {
    require_membership: 'Użytkownik musi być członkiem organizacji, aby kontynuować.',
};
export default Object.freeze(organization);
